
	$('.btn-quest').on('click', function(e) {
		e.preventDefault();
		var $button = $(this);
		$.get($button.attr('href'), function(data) {
			data = $(data);
			$("#formModal22 .custom-form").html(data.find(".custom-form"));
			$('#formModal22').modal();
		});
		return false;
	});
	$("body").on("submit", "#formModal22 form", function(e) {
		var $form = $("#formModal22 form");
		$.ajax({
			type: "POST",
			url: $form.attr("action"),
			data: $form.serialize(), // serializes the form's elements.
			success: function(data) {
				data = $(data);
				if (data.find(".custom-form").html().length > 20) {
					$("#formModal22 .custom-form").html(data.find(".custom-form"));
				} else {
					$("#formModal22 .custom-form").html(data.find(".header-text"));
					setTimeout(function() {
						$('#formModal22').modal('hide');
					}, 6000);
				}
			}
		});

		e.preventDefault();
		return false;
	});

Number.prototype.formatMoney = function(c, d, t) {

	var n = this,

		c = isNaN(c = Math.abs(c)) ? 2 : c,

		d = d == undefined ? "." : d,

		t = t == undefined ? "," : t,

		s = n < 0 ? "-" : "",

		i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),

		j = (j = i.length) > 3 ? j % 3 : 0;

	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");

};



$(document).ready(function() {

	$("#itemGallery").lightGallery({

		selector: '.product-item-gallery',

		useLeft: true,

		thumbnail: true,

		animateThumb: false,

		showThumbByDefault: false,

		zoom: false,

	});



	$('.desc-title').on('click', function() {

		$(this).toggleClass('active');

		$(this).next('.desc-text').slideToggle(400);

	})



	//  multiselect

	if (items) {

		var checkList = document.getElementById('list1');

		var items = document.getElementById('items');

		checkList.getElementsByClassName('anchor')[0].onclick = function(evt) {

			if (items.classList.contains('visible')) {

				items.classList.remove('visible');

				items.style.display = "none";

			} else {

				items.classList.add('visible');

				items.style.display = "block";

			}



		}



		items.onblur = function(evt) {

			items.classList.remove('visible');

		}

	}





	// if($('.btn-color-catalog').length){

	//   $('body').on('click', '.buy_btn_colors', function(e){

	//     e.preventDefault();

	//     var colorsChecker = false;

	//     var btn_action = $(this).closest('form').attr('action');

	//     var form = $(this).closest('form');



	//     $('.btn-color-catalog').each(function() {

	//         if($(this).find('input[type="radio"]').is(':checked')) {

	//             colorsChecker = true;

	//         }

	//       });



	//       if(colorsChecker){

	//         // window.location.href = btn_action;

	//         $(form).submit();

	//     } else {

	//         $('.txt-color-error').remove();

	//         $('.color-filter').append('<span class="txt-color-error" style="color: red;">חובה לבחור צבע.</span>');

	//       }



	//   });

	//   $('.btn-color-catalog').click(function(){

	//       $('.txt-color-error').remove();

	//   });

	// }





	$('.buy_btn_childs').click(function(e) {

		e.preventDefault();

		var colorsChecker = false;

		var colorsCheckerSize = false;

		var btn_action = $(this).closest('form').attr('action');

		var form = $(this).closest('form');



		// if (!$(this).hasClass('disabled')) {

		//   colorsChecker = true;

		// }else {

		//   colorsChecker = false;

		// }



		if ($('.btn-color-catalog').length) { // בודקים אם בחרו אחד מהצבעים

			$('.btn-color-catalog').each(function() {

				if ($(this).find('input[type="radio"]').is(':checked')) {

					colorsCheckerSize = true;

				}

			});

		}



		if ($('.sizes-filter__li-checkbox').length) { // בודקים אם בחרו אחד מהגדלים

			$('.sizes-filter__li-checkbox').each(function() {

				if ($(this).find('input[type="checkbox"]').is(':checked')) {

					colorsChecker = true;

				}

			});

		}



		if (colorsChecker && colorsCheckerSize) {

			$(form).submit();

		} else {



			if (colorsCheckerSize == false) {

				$('.txt-color-error').remove();

				$('.color-filter').closest('.color-filter').before('<div class="txt-color-error" style="font-size: 16px; font-weight: 600; color: red; margin: 10px 0;">חובה לבחור צבע.</div>');

			}



			$('.select-childs-note').remove();

			$('.sizes-filter').before('<div class="select-childs-note" style="font-size: 16px; font-weight: 600; color: red; margin: 10px; 0">חייב לבחור אחד מהאפשרויות</div>');

		}



	});



	$('.addon-calc-price').click(UpdateProductPrice);

	var addPirce = 0;

	function UpdateProductPrice() {

		$('.price__new-value-price').fadeOut();

		var orgprice = parseFloat($(this).data('org-price'));

		addPirce = 0;

		$('.addon-calc-price').each(function() {

			if ($(this).is(":checked") || $(this).is(":selected")) {

				addPirce += $(this).data('price');

			}

		});



		$('.price__new-value-price').html(parseFloat(orgprice + addPirce).formatMoney());

		$('.price__new-value-price').fadeIn();

	}



	$('.btn-color-catalog').click(function() {

		$('.txt-color-error').remove();



		// var addPirce = 0;

		// var price = parseFloat($(this).find(':checked').data('price'));

		// var oldPrice = parseFloat($(this).find(':checked').data('old-price'));



		// console.log('price '+price);

		// console.log('oldPrice '+oldPrice);



		// if(price){

		//   // $('.price__new-value-price').text(price);



		//   $('.price__new-value-price').text(parseFloat(oldPrice + price).formatMoney());

		// } else{

		//   $('.price__new-value-price').text(oldPrice);

		// }

	});



	$('.sizes-filter__checkbox').on('change', function(e) {



		var price = parseFloat($(this).find(':selected').data('price'));

		var oldPrice = parseFloat($(this).find(':selected').data('old-price'));



		var orgPrice = parseFloat($(this).data('org-price'));

		var orgOldPrice = parseFloat($(this).data('org-old-price'));



		if ($(this).val()) {

			$(this).closest('.add-to-cart-global').find('.cart-btn').css('opacity', '1').removeClass('disabled');

			$(this).closest('.add-to-cart-global').find('.select-childs-note').hide();

		} else {

			$(this).closest('.add-to-cart-global').find('.cart-btn').css('opacity', '0.5').addClass('disabled');

			$(this).closest('.add-to-cart-global').find('.select-childs-note').show();

		}



		// $('.total b').html('<b style="font-size: 65px;">'+ orgPrice + ' ₪' +'</b>'); // default price

		// $('.past b').html('<b style="font-size: 65px;">'+ orgOldPrice + ' ₪' +'</b>'); // default price



		// if (price) { // set new price

		//   $('.total b').html('<b style="font-size: 65px;">'+ price + ' ₪' +'</b>');

		// }

		// if (oldPrice) { // set new price

		//   $('.past b').html('<b style="font-size: 65px;">'+ oldPrice + ' ₪' +'</b>');

		// }



	});





});





// ##################################################



function getTimeRemaining(endtime) {

	var t = endtime - Date.parse(new Date());

	var seconds = Math.floor((t / 1000) % 60);

	var minutes = Math.floor((t / 1000 / 60) % 60);

	var hours = Math.floor((t / (1000 * 60 * 60)) % 24);

	var days = Math.floor(t / (1000 * 60 * 60 * 24));

	return {

		'total': t,

		'days': days,

		'hours': hours,

		'minutes': minutes,

		'seconds': seconds

	};

}



function initializeClock(id, endtime) {

	var clock = document.getElementById(id);

	var daysSpan = clock.querySelector('.days');

	var hoursSpan = clock.querySelector('.hours');

	var minutesSpan = clock.querySelector('.minutes');

	var secondsSpan = clock.querySelector('.seconds');



	function updateClock() {

		var t = getTimeRemaining(endtime);



		daysSpan.innerHTML = t.days;

		hoursSpan.innerHTML = ('0' + t.hours).slice(-2);

		minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);

		secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);



		if (t.total <= 0) {

			clearInterval(timeinterval);

			$('.wrapper-clockdiv').css('display', 'none');

			location.reload();

			return false;

		}

	}



	updateClock();

	var timeinterval = setInterval(updateClock, 1000);

}





$(function() {



	if ($('#clockdiv').length > 0) {

		var timedate = $('#clockdiv').data('timedate');

		if (timedate) {

			$('.wrapper-clockdiv').fadeIn();

		}



		var countDownDate = new Date(timedate).getTime();

		// var deadline = new Date(Date.parse(new Date()) + 5 * 24 * 60 * 60 * 1000);



		initializeClock('clockdiv', countDownDate);

	}



	/**

	 * Update Price of more items and add/remove images

	 */





	$(".update-buy-btn").change(function() { // buy togather

		var price = 0;



		$(this).closest('.section-recommended-package').find('.recommended-package-list-prod__item_show').last().attr('data-content-css', '+');



		$(".update-buy-btn").each(function() {

			var em = $(this);

			if (this.checked) {

				price += em.data("price");

				$(".recommended-package-list-prod__item[data-item-cs='" + em.data("item-cs") + "']").fadeIn();

				$(".recommended-package-list-prod__item[data-item-cs='" + em.data("item-cs") + "']").addClass('recommended-package-list-prod__item_show');

			} else {

				$(".recommended-package-list-prod__item[data-item-cs='" + em.data("item-cs") + "']").fadeOut();

				$(".recommended-package-list-prod__item[data-item-cs='" + em.data("item-cs") + "']").removeClass('recommended-package-list-prod__item_show');

			}



		});

		$(".update-price-on-buy").text(price.toFixed(0, 2));



		$(this).closest('.section-recommended-package').find('.recommended-package-list-prod__item_show').last().attr('data-content-css', '');



	});







	var dirRtlFlag = false;

	if ($("html").attr('dir') == 'rtl') {

		dirRtlFlag = true;

	}



	$('.prods-slider').slick({

		dots: false,

		infinite: true,

		speed: 2000,

		slidesToShow: 6,

		slidesToScroll: 1,

		arrows: true,

		autoplay: false,

		autoplaySpeed: 3000,

		rtl: dirRtlFlag,

		responsive: [{

				breakpoint: 1500,

				settings: {

					slidesToShow: 5,

					slidesToScroll: 1

				}

			}, {

				breakpoint: 1300,

				settings: {

					slidesToShow: 4,

					slidesToScroll: 1

				}

			},

			{

				breakpoint: 1100,

				settings: {

					slidesToShow: 3,

					slidesToScroll: 1

				}

			},

			{

				breakpoint: 800,

				settings: {

					slidesToShow: 2,

					slidesToScroll: 1

				}

			},
			{

				breakpoint: 550,

				settings: {

					slidesToShow: 1,

					slidesToScroll: 1

				}

			}

		]

	});



});









$(".click-label").click(function() {

	// change image

	thumb_src_big = $(this).data("thumb-src-big");

	$('#prod-gallery').slick('slickGoTo', $('a[href*="' + thumb_src_big + '"]').data('slick-index'));





	// change catalog number

	catalog_number = $(this).data("catalog-number");

	$('.product-code>span').text(catalog_number);





	// change price

	price = $(this).data("price");

	$('.current-price').text(price);



	// change old price

	old_price = $(this).data("old-price");

	$('.span-old-price').text(old_price);



	// change stock

	data_stock = $(this).data("stock");

});